import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container mx-auto" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2 md:gap-4 lg:gap-6 p-5" }
const _hoisted_3 = { class: "shadow-lg bg-blue-200 p-4 rounded-lg" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5 mainWords text-2xl" }, "Dapper Ponds", -1)
const _hoisted_5 = { class: "mb-5 mainWords text-lg" }
const _hoisted_6 = { class: "mb-5 mainWords text-lg" }
const _hoisted_7 = { class: "shadow-lg bg-blue-200 p-4 rounded-lg" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "titleWords text-2xl mb-2" }, "Current Pond ", -1)
const _hoisted_10 = {
  key: 0,
  class: "words"
}
const _hoisted_11 = {
  key: 1,
  class: "words"
}
const _hoisted_12 = { class: "mb-2 words" }
const _hoisted_13 = { class: "mb-2 words" }
const _hoisted_14 = { class: "mb-5 words" }
const _hoisted_15 = { class: "shadow-lg bg-blue-200 p-4 rounded-lg" }
const _hoisted_16 = { class: "shadow-lg bg-blue-200 p-4 rounded-lg" }
const _hoisted_17 = { class: "flex content-center" }
const _hoisted_18 = { class: "ml-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FarmerMilez = _resolveComponent("FarmerMilez")!
  const _component_FarmerRewardDisplay = _resolveComponent("FarmerRewardDisplay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, "Ponds: " + _toDisplayString(_ctx.farmAcc.stakedFarmerCount), 1),
        _createElementVNode("div", _hoisted_6, "Ducks Swimming: " + _toDisplayString(_ctx.farmAcc.gemsStaked), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          (_ctx.parseFarmerState(_ctx.farmerAcc) === 'staked')
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Ducks are swimming"))
            : (_openBlock(), _createElementBlock("p", _hoisted_11, " Ducks are drying off "))
        ]),
        _createElementVNode("div", _hoisted_12, "Ducks Swimming: " + _toDisplayString(_ctx.farmerAcc.gemsStaked), 1),
        _createElementVNode("div", _hoisted_13, " Ducks can leave the pond at " + _toDisplayString(_ctx.parseDate(_ctx.farmerAcc.minStakingEndsTs)), 1),
        _createElementVNode("div", _hoisted_14, " Feeding time ends at " + _toDisplayString(_ctx.parseDate(_ctx.farmerAcc.cooldownEndsTs)), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_FarmerMilez, {
          key: _ctx.farmerAcc.rewardA,
          farmReward: _ctx.farmAcc.rewardA,
          reward: _ctx.farmerAcc.rewardA,
          rarities: _ctx.farmerAcc.rarityPointsStaked,
          gems: _ctx.farmerAcc.gemsStaked
        }, null, 8, ["farmReward", "reward", "rarities", "gems"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_FarmerRewardDisplay, {
          key: _ctx.farmerAcc.rewardA,
          farmReward: _ctx.farmAcc.rewardA,
          reward: _ctx.farmerAcc.rewardA
        }, null, 8, ["farmReward", "reward"])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          class: "refreshButton connectText is-primary mb-5 buttonBorder",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshFarmer && _ctx.refreshFarmer(...args)))
        }, " Check $EGGZ ")
      ])
    ])
  ]))
}